import {NavigationItem} from "@/lib/interfaces/navigation";
import Link from "next/link";
import {usePathname} from "next/navigation";
import {useState} from "react";
import Image from "next/image";

type NavFullItemProps = {
    item: NavigationItem
}
export default function NavFullItem({item}: NavFullItemProps) {
    const [isOpen, setOpen] = useState(false);
    const pathname = usePathname();
    const icon = item.media.find((media) => {
        return media.role === 'icon';
    });
    return (
        <div key={item.id}
             className={`navFull-item 
                ${isOpen ? 'm-expanded' : ''} 
                ${item.collapsable ? 'm-collapsible' : ''} 
                ${pathname == item.url ? 'm-selected' : ''}`}
             onClick={() => item.collapsable ? setOpen(!isOpen) : ''}
        >
            <Link href={item.page ? `/${item.page.slug}` : item.url ?? '#'} className={`item-link`}>
                {icon &&
                    <span className="icon">
                      <Image
                        className="team-logo"
                        priority
                        src={icon.original_webp}
                        alt={item.anchor_text ?? item.title}
                        width={28}
                        height={28}
                      />
                    </span>
                }
                <span className={`label`}>{item.anchor_text ?? item.title}</span>
            </Link>
            {item.children.length > 0 &&
              <div className="item-subNav">
                  {item.children.map((subItem) => (
                      <Link key={subItem.id} href={subItem.page ? `/${subItem.page.slug}` : subItem.url ?? '#'} className={`subNav-item`}>
                          {subItem.anchor_text ?? subItem.title}
                      </Link>
                  ))}
              </div>
            }
        </div>
    )
}